import { Page } from 'layouts/Page';
import { FC } from 'react';
import { SwedBankTable } from 'components/SwedBankIntegration/index';
import { SwedBankIntegration } from 'components/SwedBankIntegration/index-old';

export const SwedBankIntegrationPage: FC = () => {
	return (
		<Page title="Swed Bank Integration – EAS Control Center">
			<SwedBankTable />
			{/* <SwedBankIntegration /> */}
		</Page>
	);
};
